export const colors = {
  black: "000000",
};
